import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectActiveRole } from '../slices/userRoleSlice';

/**
 * Component that redirects users to role-specific landing pages
 * based on their active role.
 * 
 * @param {Object} props
 * @param {string} props.defaultPath - Default path to redirect to if no role match
 * @returns {null} - This component doesn't render anything
 */
const RoleBasedRedirect = ({ defaultPath = '/landing/admin' }) => {
  const navigate = useNavigate();
  const activeRole = useSelector(selectActiveRole);

  useEffect(() => {
    // Define role-specific landing page paths
    const rolePaths = {
      admin: '/landing/admin',
      bookCreator: '/landing/book-creator',
      voiceActor: '/landing/voice-actor'
    };

    // Redirect to the appropriate landing page based on role
    const redirectPath = rolePaths[activeRole] || defaultPath;
    navigate(redirectPath, { replace: true });
  }, [activeRole, defaultPath, navigate]);

  // This component doesn't render anything
  return null;
};

export default RoleBasedRedirect;
